import { gsap } from 'gsap';
import { parse } from 'query-string';
import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

import { Page } from '../../../../helbest';
import { Drawer, ProductItem } from '../../../components';
import { getSortedParams } from '../../../components/CategoryBar/CategoryBar';
import useCategoryBar from '../../../components/CategoryBar/useCategoryBar';
import Content from '../../../components/Home/Content/Content';
import useCategoy from '../useCategory';
import CategoryBar from './CategoryBar/CategoryBar';

function fadeIn(element) {
  gsap.fromTo(element, { opacity: 0, scale: 0.5 }, { opacity: 1, scale: 1, duration: 0.8 });
}

const SubCategory = ({ Login }) => {
  const params = useParams();
  const location = useLocation();
  const queryParams = parse(location.search);
  const contentRef = useRef(null);
  const { list, layouts } = useCategoy(Login);
  const { categories, activeCategory } = useCategoryBar();
  const sortedParams = getSortedParams(params);
  const has_homepage = categories
    ?.find((citem) => Number(citem.id) === Number(sortedParams[sortedParams.length - 1]))
    ?.sub_categories?.find((pitem) => Number(pitem.id) === Number(activeCategory))?.has_homepage;

  useEffect(() => {
    if (contentRef.current) {
      fadeIn(contentRef.current);
    }
  }, [activeCategory]);

  return (
    <Page
      ref={contentRef}
      cart
      className="page-category"
      drawer={<Drawer />}
      hasHeader
      logo
      showFooter>
      <CategoryBar
        activeCategory={activeCategory}
        categories={categories}
        page="category"
        showFilterSort={!has_homepage}
      />
      <div className="page-category-product-container">
        {sortedParams[sortedParams.length - 1] === sortedParams[sortedParams.length - 2] ? (
          <>
            <Content className="pad-0" layouts={layouts} />
            {list?.map((data, i) => (
              <React.Fragment key={`${activeCategory}-${i}`}>
                <ProductItem
                  key={i}
                  data={data}
                  id={params.id}
                  productDetailId={Number(queryParams.product_id) === Number(data.product_id)}
                />
              </React.Fragment>
            ))}
          </>
        ) : has_homepage ? (
          <Content className="pad-0" layouts={layouts} />
        ) : (
          <>
            <Content className="pad-0" layouts={layouts} />
            {list?.map((data, i) => (
              <React.Fragment key={`${activeCategory}-${i}`}>
                <ProductItem
                  key={i}
                  data={data}
                  id={params.id}
                  productDetailId={Number(queryParams.product_id) === Number(data.product_id)}
                />
              </React.Fragment>
            ))}
          </>
        )}
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

export default connect(mapStateToProps)(SubCategory);
